import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
let PressItem = class PressItem extends Mixins(ViewportSizeMixin) {
    get thumbnailAspectRatio() {
        return this.mdAndUp ? 1.5 : 2;
    }
    get responsiveIframeWidth() {
        return this.mdAndUp ? '100%' : '286px';
    }
    goToLink() {
        window.open(this.link);
    }
    get responsiveIframeHeight() {
        return this.mdAndUp ? '56%' : '263px';
    }
};
__decorate([
    Prop({ type: String, required: true })
], PressItem.prototype, "description", void 0);
__decorate([
    Prop({ type: String, required: true })
], PressItem.prototype, "mediaSrc", void 0);
__decorate([
    Prop({ type: String, required: true })
], PressItem.prototype, "header", void 0);
__decorate([
    Prop({ type: String, required: true })
], PressItem.prototype, "date", void 0);
__decorate([
    Prop({ type: String, required: true })
], PressItem.prototype, "link", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], PressItem.prototype, "img", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PressItem.prototype, "video", void 0);
PressItem = __decorate([
    Component
], PressItem);
export default PressItem;
